<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Student's Assessment</h3>
          </div>
          <div class="heading-seperator"></div>
          <div style="clear: both" class="margin-bottom-10"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-for="group_tasklist in group_tasklists" class="margin-bottom-10 dash_container">
            <div class="col-12 float-left dash_container_wrapper"><b>{{ group_tasklist.group.name }}</b></div>
            <ul class="col-11 center">
              <li style="cursor: pointer" v-for="tasklist in group_tasklist.tasklist"  @click="displayTaskList(tasklist.id, group_tasklist.group.id)">
                <div class="col-11 float-left font-15">{{ tasklist.name }}</div>
                <div class="col-1 float-left override-padding fa fa-angle-right" style="font-size: 20px !important;">&nbsp;</div>
              </li>
            </ul>
            <ul class="col-11 center" v-if="group_tasklist.tasklist.length == 0">
              <li>
                <div class="col-11 float-left font-12"><i>No tasklist assigned.</i></div>
              </li>
            </ul>
            <div style="clear: both;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';

export default {
        data() {
          return {
            task_id: '',
            mentees_id: 1,
            mentees_selected: '',
            mentees: [],
            tasklists: [],
            loading: false,
            group_tasklists: [],
          }
        },
        components: {
          UserMenu,
          GoBack
        },
        methods: {
          showTasks() {
            axios.get('/student_group_tasklists', {

            })
            .then(response =>  {
              this.loading = false;
              this.group_tasklists = response.data;
            })
            .catch(function(error) {
              console.log(error);
            });
          },
          displayTaskList(tasklist_id, group_id) {
            this.navigate("/students-tasks-detail/" + group_id + "/" + tasklist_id);
          },
          navigate(path) {
        	  router.push(path);
        	},
        },
        created: function () {
          this.showTasks();
        }
    }

</script>

<style scoped>
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
    font-size: 20px;
    margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
  .container-wrapper ul {
    list-style: none;
    padding: 0px;
  }
  .container-wrapper ul li {
    padding: 5px 5px;
    //border: 1px solid #CCC;
    margin-top: 5px;
    float: left;
    width: 100%;
  }
  label {
    width: 100%;
    font-size: 15px;
  }
  .custom-select {
    font-size: 14px;
    height: 38px;
  }
  .dash_container_wrapper {
    background-color: #DDD;
    padding-top: 5px;
    height: 40px;
    border: 1px solid #DDD;
    margin-top: 0px;
    border-bottom: 1px solid #BBB;
    text-align: left;
    font-size: 18px;
    width: 100%;
  }
  .dash_container {
    border: 1px solid #DDD;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/instructor/students_tasks_list.vue